/* eslint-disable @typescript-eslint/no-unused-vars */

import { PujaPackageService, TempleService } from "td_server/services";

import {
  setLoading,
  setChadhavaTempleList,
  setChadhavaForTemple,
  setTempleChadhavaList,
  setAllPromotionalChadhava,
} from "../slices/ChadhawaSlice";
import { SPECIAL_PROMOTIONAL_TYPES } from "../../utils/Constants";
import { trackedAsync } from "../../utils/analyics/trackedAsync";

export const loading = () => async (dispatch: any, getState: any) => {
  try {
    dispatch(setLoading(true));

    return Promise.resolve("");
  } catch (e) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const getChadhavaTempleList =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=> TempleService.getChadhavaTempleList());
      if (response && response?.chadhavaOrganisations?.length > 0) {
        dispatch(setChadhavaTempleList(response?.chadhavaOrganisations));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getChadhavaForTemple =
  (
    id: string,
    isOverseas: boolean = false,
    platformFeeForChadhava: number = 0
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.getChadhavaForTemple(
        id,
        isOverseas,
        platformFeeForChadhava
      ));
      if (response && response.length > 0) {
        dispatch(setChadhavaForTemple(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const addChadhavaDetailsForTemple =
  (id: string, data: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await TempleService.addChadhavaDetailsForTemple(
        id,
        data
      );
      if (response && response.length > 0) {
        dispatch(setChadhavaForTemple(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const updateChadhavaDetailsForTemple =
  (orgId: string, id: string, data: any) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await TempleService.updateChadhavaDetailsForTemple(
        orgId,
        id,
        data
      );
      if (response && response.length > 0) {
        dispatch(setChadhavaForTemple(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const deleteChadhavaItem =
  (orgId: string, id: string) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await TempleService.deleteChadhavaItem(orgId, id);
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const updateChadhavaBenefitsForTemple =
  (orgId: string, data: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await TempleService.updateChadhavaBenefitsForTemple(
        orgId,
        data
      );
      if (response && response.length > 0) {
        dispatch(setChadhavaForTemple(response));
      }
      dispatch(setLoading(false));

      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const updateChadhavaDateForTemple =
  (orgId: string, data: string[]) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));

      //   const response: any = await TempleService.updateChadhavaDateForTemple(orgId,data);
      //   if (response && response.length > 0) {
      //     dispatch(setChadhavaForTemple(response));
      //   }
      //   dispatch(setLoading(false));

      //   return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getChadhavaForTempleList =
  (
    id: string,
    isOverseas: boolean = false,
    platformFeeForChadhava: number = 0,
    rate = 1
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.getChadhavaForTemple(
        id,
        isOverseas,
        platformFeeForChadhava,
        rate
      ));
      if (response && response.length > 0) {
        dispatch(setTempleChadhavaList(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getChadhavaForTempleWithTempleDetails =
  (
    id: string,
    isOverseas: boolean = false,
    platformFeeForChadhava: number = 0,
    rate = 1
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getChadhavaForTempleWithTempleDetails(
          id,
          isOverseas,
          platformFeeForChadhava,
          rate
        ));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const resetChadhavaList = () => async (dispatch: any, getState: any) => {
  try {
    dispatch(setChadhavaForTemple([]));
    dispatch(setLoading(false));
    return Promise.resolve([]);
  } catch (e) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const getChadhavaForTempleById =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.getChadhavaForTemplById(id));
      if (response) {
        dispatch(setChadhavaForTemple(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const addSpecialChadhavaFromWeb =
  (data: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      data["type"] = SPECIAL_PROMOTIONAL_TYPES.promotionalChadhava;
      const response: any = await TempleService.addPromotionalChadhavaFromWeb(
        data
      );
      dispatch(getAllSpecialChadhavaFromWeb());
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const editSpecialChadhavaFromWeb =
  (data: any, id: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      data["type"] = SPECIAL_PROMOTIONAL_TYPES.promotionalChadhava;
      const response: any =
        await TempleService.updatePromotionalChadhavaFromWeb(data, id);
      dispatch(getAllSpecialChadhavaFromWeb());
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const deleteSpecialChadhavaFromWeb =
  (id: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await TempleService.deletePromotionalChadhavaFromWeb(id);
      dispatch(getAllSpecialChadhavaFromWeb());
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getAllSpecialChadhavaFromWeb =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await TempleService.getPromotionalChadhavaDashBoardListActiveInactiveFromWeb();
      if (response?.promotionalList) {
        dispatch(setAllPromotionalChadhava(response.promotionalList));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getPromotionalChadhavaByNameKey =
  (
    nameKey: string,
    isOverseas: boolean = false,
    platformFeeForChadhava: number = 0,
    rate = 1
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.getPromotionalChadhavaByNameKey(
        nameKey,
        isOverseas,
        platformFeeForChadhava,
        rate
      ));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getChadhavaPackageDetailsAction =
  (pujaNameKey: string) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await trackedAsync(()=> PujaPackageService.getChadhavaPackageDetails(
        pujaNameKey
      ));

      dispatch(setLoading(false));

      return Promise.resolve(response);
    } catch (e: any) {
      console.error("Error fetching Chadhava package details:", e);
      dispatch(setLoading(false));

      return Promise.reject(
        e?.message || "Failed to fetch Chadhava package details"
      );
    }
  };


export const getPujaPackagePriceAction =
  (_priceBreakupV1: any, isOverSeas: boolean = false, rate: number = 1, isPrasad: boolean = false) =>
  async (dispatch: any) => {
    try {
      const price = await trackedAsync(()=>PujaPackageService.getPujaPackagePrice(
        _priceBreakupV1,
        isOverSeas,
        rate,
        isPrasad
      ));
      return price; 
    } catch (error: any) {
      console.error("Error fetching puja package price:", error);
      throw error;
    }
  };
  export const getChadhavaPackageListAction =
  () => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));

      const response: any = await trackedAsync(()=> PujaPackageService.getChadhavaPackageList());

      dispatch(setLoading(false));
      return Promise.resolve(response); 
    } catch (e: any) {
      console.error("Error fetching Chadhava Package List:", e);
      dispatch(setLoading(false));
      return Promise.reject(
        e?.message || "Failed to fetch Chadhava Package List"
      );
    }
  };
